import { Component, TemplateRef } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-userbox',
  templateUrl: './header-userbox.component.html'
})
export class HeaderUserboxComponent {
  currentUserName;
  letters;


  // isStationManager = false;
  // constructor(private authenticationService:AuthenticationService) {}
  ngOnInit() {
    // this.isStationManager = this.authenticationService.isStationAdmin();
    this.currentUserName = localStorage.getItem('currentUserName')
      let x = this.currentUserName;
      let nameparts = x.split(" ");
      let initials = nameparts[0].charAt(0).toUpperCase()+nameparts[1].charAt(0).toUpperCase();
      this.letters = initials;
  
  }

  modalRef: BsModalRef;
  message: string = 'Click one of the buttons inside the confirmation modals to see the event change here.';

  constructor(private modalService: BsModalService, private router: Router,) {
  }

  openModal(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered'});
  }

  confirm(): void {
      this.message = 'You clicked the \'confirm\' action!';
      this.modalRef.hide();
      localStorage.clear();
      this.router.navigateByUrl('/login')
  }

  decline(): void {
      this.message = 'You clicked the \'decline\' action!';
      this.modalRef.hide();
  }
  openSettings(){
    this.router.navigateByUrl('/home/settings');
  }
}
